import React from 'react';
import type { RedcatIconProps } from './RedcatIcon';
import { REDCAT_ICON_DEFAULT_SIZE } from './RedcatIcon';

const RedcatMapIcon = ({ size = REDCAT_ICON_DEFAULT_SIZE }: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4424_1542)">
        <rect x="1" y="1" width="11" height="13" fill="#EBEBEB" />
        <rect x="1" y="19" width="11" height="5" fill="#EBEBEB" />
        <rect x="17" y="1" width="11" height="22" fill="#EBEBEB" />
        <path
          d="M5.5 6.89495C5.5 7.28235 5.65803 7.65387 5.93934 7.9278C6.22064 8.20173 6.60217 8.35562 7 8.35562C7.39782 8.35562 7.77935 8.20173 8.06066 7.9278C8.34196 7.65387 8.5 7.28235 8.5 6.89495C8.5 6.50756 8.34196 6.13604 8.06066 5.86211C7.77935 5.58818 7.39782 5.43429 7 5.43429C6.60217 5.43429 6.22064 5.58818 5.93934 5.86211C5.65803 6.13604 5.5 6.50756 5.5 6.89495Z"
          fill="#C21213"
        />
        <path
          d="M9.8285 9.64927L7.707 11.7151C7.51949 11.8975 7.26529 12 7.00025 12C6.73521 12 6.48101 11.8975 6.2935 11.7151L4.1715 9.64927C3.61211 9.10453 3.23117 8.41049 3.07685 7.65492C2.92252 6.89935 3.00175 6.11619 3.3045 5.40446C3.60726 4.69274 4.11995 4.08442 4.77774 3.65643C5.43553 3.22844 6.20888 3 7 3C7.79112 3 8.56447 3.22844 9.22226 3.65643C9.88005 4.08442 10.3927 4.69274 10.6955 5.40446C10.9983 6.11619 11.0775 6.89935 10.9232 7.65492C10.7688 8.41049 10.3879 9.10453 9.8285 9.64927Z"
          fill="#C21213"
        />
        <path
          d="M5.5 6.89495C5.5 7.28235 5.65803 7.65387 5.93934 7.9278C6.22064 8.20173 6.60217 8.35562 7 8.35562C7.39782 8.35562 7.77935 8.20173 8.06066 7.9278C8.34196 7.65387 8.5 7.28235 8.5 6.89495C8.5 6.50756 8.34196 6.13604 8.06066 5.86211C7.77935 5.58818 7.39782 5.43429 7 5.43429C6.60217 5.43429 6.22064 5.58818 5.93934 5.86211C5.65803 6.13604 5.5 6.50756 5.5 6.89495Z"
          stroke="#C21213"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.8285 9.64927L7.707 11.7151C7.51949 11.8975 7.26529 12 7.00025 12C6.73521 12 6.48101 11.8975 6.2935 11.7151L4.1715 9.64927C3.61211 9.10453 3.23117 8.41049 3.07685 7.65492C2.92252 6.89935 3.00175 6.11619 3.3045 5.40446C3.60726 4.69274 4.11995 4.08442 4.77774 3.65643C5.43553 3.22844 6.20888 3 7 3C7.79112 3 8.56447 3.22844 9.22226 3.65643C9.88005 4.08442 10.3927 4.69274 10.6955 5.40446C10.9983 6.11619 11.0775 6.89935 10.9232 7.65492C10.7688 8.41049 10.3879 9.10453 9.8285 9.64927Z"
          stroke="#C21213"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 6.91086C5.5 7.29825 5.65803 7.66977 5.93934 7.9437C6.22064 8.21763 6.60217 8.37152 7 8.37152C7.39782 8.37152 7.77935 8.21763 8.06066 7.9437C8.34196 7.66977 8.5 7.29825 8.5 6.91086C8.5 6.52346 8.34196 6.15194 8.06066 5.87801C7.77935 5.60409 7.39782 5.4502 7 5.4502C6.60217 5.4502 6.22064 5.60409 5.93934 5.87801C5.65803 6.15194 5.5 6.52346 5.5 6.91086Z"
          fill="white"
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="7.5" stroke="#C4C4C4" />
      <defs>
        <clipPath id="clip0_4424_1542">
          <rect width="24" height="24" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RedcatMapIcon;
